import Label from './Label';
import Input from './Input';
import Button from './Button';
import Dropdown from './Dropdown';
import Checkbox from './Checkbox';

export default {
    install(Vue) {

        Vue.component(Label.name, Label);
        Vue.component(Input.name, Input);
        Vue.component(Button.name, Button);
        Vue.component(Dropdown.name, Dropdown);
        Vue.component(Checkbox.name, Checkbox);

    }
}